export const BuildInfo = {timestamp:1791474417000}
